import { render, staticRenderFns } from "./DesignerEstagio.vue?vue&type=template&id=3a203c22&"
import script from "./DesignerEstagio.vue?vue&type=script&lang=ts&"
export * from "./DesignerEstagio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports